const initialEmployee = {
    employees: [],
    allempemailids : [],
    allempmobilenos : [],
    employeemessages : {},
};

const employeeReducer = (employee = initialEmployee, action) => {
    switch (action.type) {

        case 'UPDATE_EMPLOYEE':
          return {
            ...employee, employeemessages: action.payload.data
          };
        case "ADD_EMPLOYEE":
            return {
                ...employee, employeemessages: action.payload.data
            };
        case 'GET_EMPLOYEE':
            return {
                ...employee, employees: action.payload.data
            };
        case 'ALL_EMPLOYEE_EMAILID':
            return {
                ...employee, allempemailids: action.payload.data
            };
        case 'ALL_EMPLOYEE_MOBILENO':
            return {
                ...employee, allempmobilenos: action.payload.data
            };
        case "EMPLOYEE_STATUS":
            return {
                ...employee, employeemessages: action.payload.data
            };
            
        default:
            return employee;
    }
}
export default employeeReducer;